export default __webpack_public_path__ + "static/media/640_dummy2016-ernaehrungsberatung01-mobile-de.77ef50be.png";